import config from '@/assets/config'
import { getFrames } from '@/utils'

const ww = window.innerWidth
const wh = window.innerHeight

// 场景基础数据
const s3ScrollD = config.scenesScrollD[2]
const s3ScrollT = config.scenesScrollT[2]
// 背景
const s3BgFadeT = 0.1 * s3ScrollT
const s3BgScrollD = s3ScrollD + s3BgFadeT // 0.1T
const s3BgScrollT = 0.2 * s3ScrollT // 0.3T
const s3BgW = wh * 2600 / 2436
const s3BgScrollW = s3BgW - ww
// 门
const s3DoorW = wh * 0.511 * 704 / 1244
const s3DoorX = 470 * s3BgW / 2600
const s3BookcaseX = s3DoorX + s3DoorW + 250 / 2600 * s3BgW
const s3LightX = s3DoorX + s3DoorW + 710 / 2600 * s3BgW
const s3ClockX = s3DoorX + s3DoorW + 1034 / 2600 * s3BgW
const s3CalenderX = s3DoorX + s3DoorW + 1040 / 2600 * s3BgW
const s3ChildX = s3DoorX + s3DoorW - 270 / 2600 * s3BgW
// 母亲
const s3MotherX = s3DoorX + s3DoorW * 0.5
const s3MotherH = 0.48 * wh
const s3MotherW = 0.48 * wh * 970 / 1900
const s3MotherY = 0.88 * wh - s3MotherH / 2
const s3MotherH2 = 0.78 * wh
const s3MotherW2 = 0.78 * wh * 970 / 1900
const s3MotherY2 = wh * 0.739
const s3MotherX2 = s3MotherX + s3DoorW * 0.5 - s3BgScrollW + s3MotherW2 * 0.34
// 时钟
const s3ClockW = wh * 0.1 * 247 / 243
const s3HourX = s3ClockX + s3ClockW / 2
const s3MinuteX = s3ClockX + s3ClockW / 2

// 对话
const s3TalkT = 0.55 * s3ScrollT
const s3TalkD = s3BgScrollD + s3BgScrollT // 0.3T
// 散开
const s3EndD = s3TalkD + s3TalkT // 0.85T
const s3EndT = 0.15 * s3ScrollT
const s3BookcaseW = wh * 0.572 * 675 / 1394

const s4ScrollD = config.scenesScrollD[3]
const s4ScrollT = config.scenesScrollT[3]

// 对话
const s3Talk1X = s3LightX - s3MotherW * 0.3
const s3Talk2X = s3LightX + s3MotherW * 0.5

const s3Talk1D = s3TalkD
const s3Talk1T = s3ScrollT * 0.08
const s3Talk1H = wh * 0.325
const s3Talk1W = s3Talk1H * 203 / 792
const s3Talk2D = s3TalkD + s3ScrollT * 0.06
const s3Talk2T = s3ScrollT * 0.06
const s3Talk2H = wh * 0.377
const s3Talk2W = s3Talk2H * 217 / 918

const s3TextD = s3Talk2D + s3Talk2T * 2
const s3TextT = s3ScrollT * 0.05

const animations = {
  s3_bg: [
    {
      delay: s3ScrollD,
      duration: s3BgFadeT,
      from: { alpha: 0 },
      to: { alpha: 1 }
    },
    {
      delay: s3BgScrollD,
      duration: s3BgScrollT,
      from: { x: 0 },
      to: { x: -s3BgW + ww }
    },
    {
      delay: s3EndD,
      duration: s3EndT,
      to: { alpha: 0 }
    }
  ],
  s3_door: [
    {
      delay: s3ScrollD,
      duration: s3BgFadeT,
      from: { alpha: 0 },
      to: { alpha: 1 }
    },
    {
      delay: s3BgScrollD,
      duration: s3BgScrollT,
      from: { x: s3DoorX },
      to: { x: s3DoorX - s3BgScrollW }
    },
    {
      delay: s3EndD,
      duration: s3EndT,
      to: { x: s3DoorX - s3BgScrollW - s3BookcaseW }
    }
  ],
  s3_bookcase: [
    {
      delay: s3ScrollD,
      duration: s3BgFadeT,
      from: { alpha: 0 },
      to: { alpha: 1 }
    },
    {
      delay: s3BgScrollD,
      duration: s3BgScrollT,
      from: { x: s3BookcaseX },
      to: { x: s3BookcaseX - s3BgScrollW }
    },
    {
      delay: s3EndD,
      duration: s3EndT,
      to: { x: -s3BookcaseW }
    }
  ],
  s3_light: [
    {
      delay: s3BgScrollD,
      duration: s3BgScrollT,
      from: { x: s3LightX },
      to: { x: s3LightX - s3BgScrollW }
    },
    {
      delay: s3EndD,
      duration: s3EndT,
      to: { y: -0.266 * wh }
    }
  ],
  s3_clock: [
    {
      delay: s3BgScrollD,
      duration: s3BgScrollT,
      from: { x: s3ClockX },
      to: { x: s3ClockX - s3BgScrollW }
    },
    {
      delay: s4ScrollD,
      duration: s4ScrollT * 0.1,
      from: { alpha: 1 },
      to: { alpha: 0 }
    }
  ],
  s3_hour: [
    {
      delay: s3BgScrollD,
      duration: s3BgScrollT,
      from: { x: s3HourX },
      to: { x: s3HourX - s3BgScrollW }
    },
    {
      delay: s3EndD,
      duration: s3EndT,
      to: { rotation: Math.PI * 2 * 240 / 360 }
    },
    {
      delay: s4ScrollD,
      duration: s4ScrollT * 0.1,
      from: { alpha: 1 },
      to: { alpha: 0 }
    }
  ],
  s3_minute: [
    {
      delay: s3BgScrollD,
      duration: s3BgScrollT,
      from: { x: s3MinuteX },
      to: { x: s3MinuteX - s3BgScrollW }
    },
    {
      delay: s3EndD,
      duration: s3EndT,
      to: { rotation: Math.PI * 2 * 8 }
    },
    {
      delay: s4ScrollD,
      duration: s4ScrollT * 0.1,
      from: { alpha: 1 },
      to: { alpha: 0 }
    }
  ],
  s3_calender: [
    {
      delay: s3EndD,
      duration: s3EndT,
      from: { x: s3CalenderX - s3BgScrollW },
      to: { x: ww }
    },
    {
      delay: s3BgScrollD,
      duration: s3BgScrollT,
      from: { x: s3CalenderX },
      to: { x: s3CalenderX - s3BgScrollW }
    }
  ],
  s3_mother: [
    {
      delay: s3EndD,
      duration: s3EndT,
      from: { y: s3MotherY2 },
      to: { y: s3MotherY2 + s3MotherH2 }
    },
    {
      delay: s3ScrollD,
      duration: s3BgFadeT,
      from: { alpha: 0 },
      to: { alpha: 1 }
    },
    {
      delay: s3BgScrollD,
      duration: s3BgScrollT,
      frames: getFrames('s3_mother', 8, 1)
    },
    {
      delay: s3BgScrollD,
      duration: s3BgScrollT,
      from: { x: s3MotherX, y: s3MotherY, width: s3MotherW, height: s3MotherH },
      to: { x: s3MotherX2, y: s3MotherY2, width: s3MotherW2, height: s3MotherH2 }
    }
  ],
  s3_child: [
    {
      delay: s3ScrollD,
      duration: s3BgFadeT,
      from: { alpha: 0 },
      to: { alpha: 1 }
    },
    {
      delay: s3BgScrollD,
      duration: s3BgScrollT,
      from: { x: s3ChildX },
      to: { x: s3ChildX - s3BgScrollW }
    },
    {
      delay: s3EndD,
      duration: s3EndT,
      to: { y: wh + s3MotherH2 }
    }
  ],
  s3_textnew: [
    {
      delay: s3TextD,
      duration: s3TextT,
      from: { alpha: 0 },
      to: { alpha: 1, yoyo: true, repeat: 1, repeatDelay: s3TextT * 4 }
    }
  ],
  s3_talk1: [
    {
      delay: s3BgScrollD,
      duration: s3BgScrollT,
      from: { x: s3Talk1X },
      to: { x: s3Talk1X - s3BgScrollW }
    },
    {
      delay: s3Talk1D,
      duration: s3Talk1T,
      from: { alpha: 0, width: 0, height: 0 },
      to: { alpha: 1, width: s3Talk1W, height: s3Talk1H, yoyo: true, repeat: 1, repeatDelay: s3Talk1T * 4, ease: 'ease' }
    }
  ],
  s3_talk2: [
    {
      delay: s3BgScrollD,
      duration: s3BgScrollT,
      from: { x: s3Talk2X },
      to: { x: s3Talk2X - s3BgScrollW }
    },
    {
      delay: s3Talk2D,
      duration: s3Talk2T,
      from: { alpha: 0, width: 0, height: 0 },
      to: { alpha: 1, width: s3Talk2W, height: s3Talk2H, yoyo: true, repeat: 1, repeatDelay: s3Talk2T * 4, ease: 'ease' }
    }
  ]
}

export default animations



// WEBPACK FOOTER //
// ./src/assets/scenes/s3/spritesAnimations.js